import axiosPost from "../axiosPost";

/**
 * Obtiene eventos de entrada/salida (GateEventoGet).
 * Con page y pageSize devuelve { result, total, status }; sin ellos, el array de resultados.
 * @param {object} params - Filtros: fechas, zona, lugar, nombres, documento, usuarioId y paginación.
 * @param {object} credentials - Credenciales Hooli del usuario.
 */
export const eventoGet = async ({
    fechaDesde,
    fechaHasta,
    gateZonaId,
    gateLugarId,
    usuarioNombres,
    usuarioNroDeDocumentoX = null,
    usuarioId = null,
    page = null,
    pageSize = null,
}, credentials) => {
    const body = {
        service: "GateEventoGet",
        params: {
            merchantId: credentials.merchantId,
            fechaDesde,
            fechaHasta,
            gateZonaId,
            gateLugarId,
            usuarioNombres,
            usuarioNroDeDocumentoX,
            usuarioId,
            page,
            pageSize,
        },
    };

    const result = await axiosPost(body, credentials);

    if (page !== null && pageSize !== null) {
        return {
            result: result.result,
            total: result.status.id,
            status: result.status,
        };
    }

    return result.result;
};
